export const ProjectStatus = {
  SCOPING: 'SCOPING',
  TASKING: 'TASKING',
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const;

export const TaskStatus = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const;

export const TaskPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
} as const;

export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus];
export type TaskPriority = (typeof TaskPriority)[keyof typeof TaskPriority];
export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

/**
 * The three user-facing status buckets after collapsing SCOPING/TASKING/TODO
 * into a single 'TODO' bucket (see `src/utils/status.ts` `collapseStatus`).
 */
export const DISPLAY_STATUSES = ['TODO', 'IN_PROGRESS', 'DONE'] as const;
export type DisplayStatus = (typeof DISPLAY_STATUSES)[number];
